/**
 * Demo Mode Utilities
 * 
 * Handles demo mode state via localStorage.
 * When demo mode is enabled, API calls are routed to the demo environment.
 */

export const DEMO_MODE_KEY = 'demoModeEnabled';


export function isDemoModeEnabled(): boolean {
    try {
        return localStorage.getItem(DEMO_MODE_KEY) === 'true';
    } catch (err) {
        console.error('Error reading demo mode from localStorage:', err);
        return false;
    }
}

export function enableDemoMode(): void {
    try {
        localStorage.setItem(DEMO_MODE_KEY, 'true');
        console.log('Demo mode enabled - reloading to apply changes');
        window.location.reload();
    } catch (err) {
        console.error('Error enabling demo mode:', err);
    }
}

export function disableDemoMode(): void {
    try {
        localStorage.removeItem(DEMO_MODE_KEY);
        console.log('Demo mode disabled - reloading to apply changes');
        window.location.reload();
    } catch (err) {
        console.error('Error disabling demo mode:', err);
    }
}


export function toggleDemoMode(): void {
    if (isDemoModeEnabled()) {
        disableDemoMode();
    } else {
        enableDemoMode();
    }
}

